import { ChangeDetectionStrategy, Component, effect, ElementRef, inject, input } from '@angular/core';
import { EditorIdService } from '../../providers/editor-id.service';


@Component({
    selector: 'app-fs-button',
    templateUrl: './fs-button.component.html',
    styleUrls: ['./fs-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
})
export class FsButtonComponent {

  public value = input.required<string>();
  private hostElement = inject(ElementRef);
  private editorIdService = inject(EditorIdService);

  public constructor() {
    effect(() => {
      this.editorIdService.addEditorId(this.hostElement.nativeElement, this.value());
    })
  }

}
